import { Search } from "lucide-react";

import { openGlobalSearch } from "@/components/search/global-search";
import { Button } from "@/components/ui/button";

/**
 * The way into global search from the page header (#640, #656).
 *
 * From `md` up it is a search bar you can see and click, with the shortcut
 * beside it; a magnifier alone was easy to miss. It is a button that opens the
 * same panel as Ctrl+K and "/", not a second input, so there is one search to
 * keep right. On a phone the header has no room for a bar, so it stays the
 * icon.
 */
export function SearchButton() {
  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="icon-sm"
        className="md:hidden"
        aria-label="Search everything (Ctrl+K)"
        title="Search everything (Ctrl+K or /)"
        onClick={openGlobalSearch}
      >
        <Search aria-hidden />
      </Button>
      <button
        type="button"
        aria-label="Search everything (Ctrl+K)"
        title="Search everything (Ctrl+K or /)"
        onClick={openGlobalSearch}
        className="border-input bg-background text-muted-foreground hover:bg-accent hover:text-accent-foreground focus-visible:ring-ring/50 hidden h-8 w-64 items-center gap-2 rounded-md border px-2.5 text-left text-sm shadow-xs focus-visible:ring-[3px] focus-visible:outline-none md:flex lg:w-80"
      >
        <Search aria-hidden className="size-4 shrink-0" />
        <span className="min-w-0 flex-1 truncate">
          Search orders, products, contacts…
        </span>
        <kbd className="rounded border px-1.5 py-0.5 text-[11px]">Ctrl K</kbd>
      </button>
    </>
  );
}
